import type { TripItineraryData, TripStop } from 'tripPlanner/api/types'

export function hasTimelineStopItems(stop: TripStop): boolean {
  return (stop.days?.some(day => day.items.length > 0) ?? false)
    || (stop.itemsWithoutDay?.length ?? 0) > 0
}

export function shouldHideTimelineOriginStop(stop: TripStop): boolean {
  return stop.stopType === 'ORIGIN' && !hasTimelineStopItems(stop)
}

export function isTimelineStopSectionVisible(stop: TripStop): boolean {
  return !shouldHideTimelineOriginStop(stop)
}

/** Hotels/experiences browse tiles belong on destination stops only. */
export function shouldShowTimelineStopProductTiles(stop: TripStop | undefined): boolean {
  return !!stop && stop.stopType !== 'ORIGIN'
    && stop.isPlaceLookupApplicable !== false
    && !stop.destinationRefinementPrompt?.trim()
}

function stopHasVisibleTransport(stop: TripStop): boolean {
  return stop.transports?.some(transport => transport.options.length > 0) ?? false
}

/**
 * Returns true when TripPlanCanvas would render at least one visible stop or transport.
 * Used to decide whether the timeline tab should show the canvas or the empty placeholder.
 */
export function hasRenderableTimelineContent(itineraryData: TripItineraryData | undefined): boolean {
  const stops = itineraryData?.stops
  if (!stops?.length) return false

  return stops.some(stop => isTimelineStopSectionVisible(stop) || stopHasVisibleTransport(stop))
}
